module.exports = __webpack_public_path__ + "img/google.5f03f12f.svg";